import { connect } from 'react-redux';
import {
  fetchInactiveSelfAuthorizations,
  fetchViewByList,
  getViewByListOptions,
  resetEnabledOptions,
  setAuthorizationBy,
  setHasUnsavedChanges,
  setParams,
} from '../../store/createNewSelfAuthorizationSlice';
import { getCurrentSelection } from '../../store/selfAuthorizationsSlice';

import Details from './Details';

const mapState = state => {
  const { authorizationBy, params, inactiveListLoading } =
    state.loadingManagement.createNewSelfAuth;
  const { activeSelfAuthTab } = state.loadingManagement.selfAuthorizations;

  return {
    activeSelfAuthTab,
    authorizationBy,
    currentSelection: getCurrentSelection(state),
    inactiveListLoading,
    params,
    viewByListOptions: getViewByListOptions(state),
  };
};

const mapDispatchToProps = {
  fetchInactiveSelfAuthorizations,
  fetchViewByList,
  resetEnabledOptions,
  setAuthorizationBy,
  setHasUnsavedChanges,
  setParams,
};

export default connect(mapState, mapDispatchToProps)(Details);
